// Babel Dependencies
// If using es6 you might need for browser compatablity.
// This includes core-js but makes bloats the JS considerably. Use only if needed.
// import "babel-polyfill";

// Scripts
import "./touch-menu";
import "./dropdown-menu";
import "./desktop-search";

import "./video-gallery";

import "./content-slider";

import "./last-chance-popup";

import "./clipboard";

import "./faq_section";

import "./sponsors";

import "./devices";
import "./counter";

import "./parallax-content";

import "./product-testimonials";

import "./testimonial-slider";

import "./tabbed-content";


import "./form-fixes";